import genericMapConstants from './genericMapConstants';
import loadingActions from '../loading/loadingActions';
import GenericMapService from '../../../services/genericMapService';
import GenericMapUtils from '../../../utils/genericMapUtils';

function getRoutes(routeIds, ignoreCache = false, silent = false) {
  return (dispatch) => {
    if (!silent) {
      dispatch(
        loadingActions.addLoadingInProgress(
          genericMapConstants.GET_GENERIC_MAP_ROUTES
        )
      );
    }

    return GenericMapService.getRoutesByIds(routeIds, ignoreCache)
      .then(
        (genericMapRoutes) =>
          dispatch(getRoutesSuccess(genericMapRoutes, routeIds)),
        (error) => dispatch(getRoutesFailure(JSON.stringify(error)))
      )
      .finally(() => {
        dispatch(
          loadingActions.removeLoadingInProgress(
            genericMapConstants.GET_GENERIC_MAP_ROUTES
          )
        );
      });
  };

  function getRoutesSuccess(genericMapRoutes) {
    return {
      type: genericMapConstants.GET_GENERIC_MAP_ROUTES_SUCCESS,
      genericMapRoutes,
      routeIds,
    };
  }
  function getRoutesFailure(error) {
    return { type: genericMapConstants.GET_GENERIC_MAP_ROUTES_FAILURE, error };
  }
}

/** ----- GET DATA ------ **/

function getData(drawings, routes, ignoreCache = false, silent = false) {
  return (dispatch) => {
    if (!silent) {
      dispatch(
        loadingActions.addLoadingInProgress(
          genericMapConstants.GET_GENERIC_MAP_DATA
        )
      );
    }

    return GenericMapService.getGenericMapData(drawings, ignoreCache)
      .then(
        (genericMapData) => {
          const groupedAgreements = GenericMapUtils.groupDataByAgreements(
            genericMapData,
            routes
          );

          const genericMapPlaces =
            GenericMapUtils.groupDataByPlaces(genericMapData);

          const genericMapAgreementLines = GenericMapUtils.selectAgreementLines(
            genericMapData,
            routes
          );

          const genericMapRouteLines =
            GenericMapUtils.groupDataByRouteLines(genericMapData);

          const genericMapRoutes =
            GenericMapUtils.groupDataByRoutes(genericMapData);

          const groupedData = {
            agreements: groupedAgreements,
            places: genericMapPlaces,
            routes: genericMapRoutes,
            agreementLines: genericMapAgreementLines,
            routeLines: genericMapRouteLines,
          };

          const groupedDisplayedData = {
            agreements: GenericMapUtils.groupDataByAgreements(
              genericMapData,
              routes,
              true
            ),
            places: GenericMapUtils.groupDataByPlaces(genericMapData, true),
            agreementLines: GenericMapUtils.selectAgreementLines(
              genericMapData,
              routes,
              true
            ),
            // routeLines: groupDisplayedElements(genericMapRouteLines),
          };

          dispatch(getDataSuccess(groupedData));
          dispatch(setDisplayedData(groupedDisplayedData));
        },
        (error) => dispatch(getDataFailure(JSON.stringify(error)))
      )
      .finally(() => {
        dispatch(
          loadingActions.removeLoadingInProgress(
            genericMapConstants.GET_GENERIC_MAP_DATA
          )
        );
      });
  };

  function getDataSuccess(genericMapData) {
    return {
      type: genericMapConstants.GET_GENERIC_MAP_DATA_SUCCESS,
      genericMapData,
    };
  }
  function setDisplayedData(displayedData) {
    return {
      type: genericMapConstants.SET_DISPLAYED_MAP_DATA,
      displayedData,
    };
  }
  function getDataFailure(error) {
    return { type: genericMapConstants.GET_GENERIC_MAP_DATA_FAILURE, error };
  }
}

/** ----- GET DRAWN SHAPES ----- **/
function getDrawnShapes(genericMapDrawnShapes) {
  return (dispatch) => {
    dispatch(getDrawnShapesSuccess(genericMapDrawnShapes));
  };

  function getDrawnShapesSuccess(genericMapDrawnShapes) {
    return {
      type: genericMapConstants.GET_GENERIC_MAP_DRAWN_SHAPES_SUCCESS,
      genericMapDrawnShapes,
    };
  }
}

/** ----- SET DRAWN SHAPES ----- **/
function setDrawnShapes(shapesData, silent = false) {
  return (dispatch) => {
    dispatch(setDrawnShapesSuccess(shapesData));
  };
  function setDrawnShapesSuccess(updatedShapes) {
    return {
      type: genericMapConstants.SET_GENERIC_MAP_DRAWN_SHAPES_SUCCESS,
      updatedShapes,
    };
  }
}

function setGenericMapLayers(layers) {
  return (dispatch) => {
    dispatch(setLayers(layers));
  };
  function setLayers(layers) {
    return {
      type: genericMapConstants.SET_GENERIC_MAP_LAYERS,
      layers,
    };
  }
}

function setMapCornerCoordinates(cornerData) {
  return (dispatch) => {
    dispatch(setMapCorners(cornerData));
  };
  function setMapCorners(mapCorners) {
    return {
      type: genericMapConstants.SET_MAP_CORNER_COORDINATES,
      mapCorners,
    };
  }
}

function setAgreementsVisible(isVisible) {
  return (dispatch) => {
    dispatch(showAgreements(isVisible));
    if (!isVisible) {
      clearData(dispatch);
    }
  };
  function showAgreements(isVisible) {
    return {
      type: genericMapConstants.SET_AGREEMENTS_VISIBLE_FLAG,
      isVisible,
    };
  }
}

function setZoomLevel(zoomLevel) {
  return (dispatch) => {
    dispatch(storeZoomLevel(zoomLevel));
  };
  function storeZoomLevel(zoomLevel) {
    return {
      type: genericMapConstants.SET_ZOOM_LEVEL,
      zoomLevel,
    };
  }
}

function setZoomWarningVisibility(isHidden) {
  return (dispatch) => {
    dispatch(setVisibility(isHidden));
  };
  function setVisibility(isHidden) {
    return {
      type: genericMapConstants.SET_ZOOM_WARNING_BANNER_VISIBILITY,
      isHidden,
    };
  }
}

function clearData(dispatch) {
  const groupedData = {
    agreements: [],
    places: [],
    routes: [],
    agreementLines: [],
    routeLines: [],
  };

  const groupedDisplayedData = {
    agreements: [],
    places: [],
  };
  dispatch(getDataSuccess(groupedData));
  dispatch(setDisplayedData(groupedDisplayedData));

  function getDataSuccess(genericMapData) {
    return {
      type: genericMapConstants.GET_GENERIC_MAP_DATA_SUCCESS,
      genericMapData,
    };
  }
  function setDisplayedData(displayedData) {
    return {
      type: genericMapConstants.SET_DISPLAYED_MAP_DATA,
      displayedData,
    };
  }
}

function setHighlightedMarker(category, value) {
  return (dispatch) => {
    dispatch(setHighlighted(category, value));
  };
  function setHighlighted(category, value) {
    return {
      type: genericMapConstants.SET_HIGHLIGHTED_MARKERS,
      highlights: {
        category: category,
        value,
        value,
      },
    };
  }
}

function setFilterType(filterType) {
  return (dispatch) => {
    dispatch(setType(filterType));
  };
  function setType(filterType) {
    return {
      type: genericMapConstants.SET_FILTER_TYPE,
      filterType,
    };
  }
}

export default {
  getRoutes,
  getData,
  getDrawnShapes,
  setDrawnShapes,
  setGenericMapLayers,
  setMapCornerCoordinates,
  setAgreementsVisible,
  setZoomLevel,
  setZoomWarningVisibility,
  clearData,
  setHighlightedMarker,
  setFilterType,
};
